export default __webpack_public_path__ + "static/media/volume_on_branco.c3aff1e4.svg";